import React, { useEffect } from 'react';
import { useNewsNavigation } from '../../hooks/useNewsNavigation';
import { useSearchParams } from 'react-router-dom';
import { extractFilterFromSearchParams } from '../../containers/news/NewsStoriesFilterContainer';
import { NewsStoriesContainer } from '../../containers/news/NewsStoriesContainer';
import { logNewsEvent } from '../../services/news';
import { analytics } from '../../services/firebase';

/** Navigator Page taking care of displaying a list of stories */
export const NewsStoriesPage = () => {
    const newsNavigation = useNewsNavigation();
    const [searchParams,] = useSearchParams();

    useEffect(() => {
        logNewsEvent("Stories");
    }, [])

    useEffect(() => {
        const searchTerm = searchParams.toString();
        if (!!searchTerm) {
            analytics.logEvent("search", { search_term: searchTerm });
        }
    }, [searchParams])

    return <NewsStoriesContainer {...newsNavigation}
        {...extractFilterFromSearchParams(searchParams)}
    />;
}
